const validEmail = field => {
    if (!field.value.includes('@') && field.value.trim() !== "") {
      document.getElementById(field.id).style.border = "1px solid red"; return false;
    } else {
      document.getElementById(field.id).style.border = "1px solid lightgray"; return true
    };
}

export default validEmail